import initCubus from '@/cubus/services/initCubus'

const { cubusService } = initCubus()

export default cubusService
